exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info {\n  width: 22px;\n  height: 22px;\n  background: #fff;\n  border-radius: 100%;\n  text-align: center;\n  line-height: 100%;\n  border: 1px solid #d1d6df; }\n  .info .icon-info-circle {\n    font-size: 20px; }\n\n.info-content {\n  position: absolute;\n  bottom: 50px;\n  width: 350px;\n  padding: 30px;\n  background: #bcd52f;\n  z-index: 100;\n  opacity: 0;\n  left: -9999px;\n  line-height: 1.3;\n  font-size: 16px; }\n  .info-content:after {\n    top: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-top-color: #bcd52f;\n    border-width: 25px;\n    margin-left: -25px; }\n  .info-content.show {\n    left: -165px;\n    opacity: 1; }\n\n.close {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  padding: 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/um.stamps/src/app/shared/tooltip/tooltip.component.scss
// module id = ../../../../../src/app/shared/tooltip/tooltip.component.scss
// module chunks = main